// import { useState } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate } from "react-router-dom";

// import styles from "./checkoutaddress.module.css";
// import { HeadingTitle, Loader } from "../../../../components/shared/index";
// import { useUserAddressListQuery } from "../../../../queries/useUserAddress";
// import { useOrderSummary } from "../../../../hooks/useOrderSummary";
// import { FaPlus } from "react-icons/fa";

// import { ErrorFallback, ErrorQueryBoundary } from "../../../../components";
// import CheckoutOrderSummary from "../CheckoutPayment/CheckoutOrderSummary";
// import toast from "react-hot-toast";
// import UserAddressList from "./UserAddressList";
// import AddMyAddress from "../../UserProfileOverview/MyAddress/AddMyAddress/AddMyAddress";

// const CheckoutAddress = () => {
//   const navigate = useNavigate();
//   const [countryId] = useState(101);
//   const [showForm, setShowForm] = useState(false);

//   const [selectedAddress, setSelectedAddress] = useState(() => {
//     const saved = localStorage.getItem("checkoutAddress");
//     return saved ? JSON.parse(saved) : null;
//   });

//   const { data: addressList = [], isPending: isPendingAddress } =
//     useUserAddressListQuery();

//   const savedShipping = JSON.parse(localStorage.getItem("shipping-rules"));

//   const {
//     cartItems,
//     isPending: isCartPending,
//     subtotal,
//     shipping,
//     tax,
//     total,
//     totalQty,
//       hasPrescriptionItem,
//   } = useOrderSummary(savedShipping); 

//   const orderSummary = {
//     subtotal,
//     shipping,
//     tax,
//     total,
//     totalQty,
//   };

//   const existingAddress = {
//     name: "",
//     email: "",
//     phone: "",
//     country_id: String(countryId),
//     state_id: "",
//     city: "",
//     zip: "",
//     address: "",
//     users_id: "",
//   };

//   const {
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     defaultValues: existingAddress,
//   });

//   const onSubmit = () => {
//     if (!selectedAddress) {
//       toast.error("Please select an address");
//       return;
//     }
//     const newUserAddress = {
//       id: selectedAddress.id,
//       name: selectedAddress.name,
//       email: selectedAddress.email,
//       phone: selectedAddress.phone,
//       country_id: selectedAddress.country_id,
//       state_id: selectedAddress.state_id,
//       city: selectedAddress.city,
//       zip: selectedAddress.zip,
//       address: selectedAddress.address,
//     };

//     localStorage.setItem("checkoutAddress", JSON.stringify(newUserAddress));

//    if (hasPrescriptionItem) {
//   navigate("/checkout/prescription");
// } else {
//   navigate("/checkout/payment");
// }
//   };

//   const handleNextToPay = () => handleSubmit(onSubmit)();

//   const handleSelectAddress = (address) => {
//     setSelectedAddress(address);
//     localStorage.setItem("checkoutAddress", JSON.stringify(address));
//   };

//   return (
//     <div className={styles.checkoutContainer}>
//       <div className={styles.leftSection}>
//         <HeadingTitle text="Delivery Address" style={styles.pageTitle} />

//         <div
//           className={styles.addAddressCard}
//           onClick={() => setShowForm(true)}
//         >
//           <span className={styles.plus}>
//             <FaPlus size={25} />
//           </span>
//           <p>Add New  Address</p>
//         </div>

//         {showForm && (
//           <div className={styles.formWrapper}>
//             <AddMyAddress
//               mode="add"
//               onClose={() => setShowForm(false)}
//               onSave={(newAddress) => {
//                 setSelectedAddress(newAddress);
//                 setShowForm(false);
//               }}
//             />
//           </div>
//         )}

//         <ErrorQueryBoundary
//           fallback={<Loader title="Loading user addresses.." />}
//           errorFallback={<ErrorFallback />}
//         >
//           {isPendingAddress ? (
//             <Loader title="Loading user addresses.." />
//           ) : (
//             <UserAddressList
//               addressList={addressList}
//               selectedAddress={selectedAddress}
//               onSelect={handleSelectAddress}
//             />
//           )}
//         </ErrorQueryBoundary>
//       </div>

//       <div className={styles.rightSection}>
//         {isCartPending ? (
//           <Loader title="Loading orders..." />
//         ) : (
//           <CheckoutOrderSummary
//             cartItems={cartItems}
//             orderSummary={orderSummary}
//             isCartPending={isCartPending}
//             handlePlaceOrder={handleNextToPay}
//             isOrderPlacePending={false}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default CheckoutAddress;

import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate ,useLocation } from "react-router-dom";

import styles from "./checkoutaddress.module.css";
import { HeadingTitle, Loader } from "../../../../components/shared/index";
import { useUserAddressListQuery } from "../../../../queries/useUserAddress";

import { FaPlus } from "react-icons/fa";

import { ErrorFallback, ErrorQueryBoundary } from "../../../../components";
import CheckoutOrderSummary from "../CheckoutPayment/CheckoutOrderSummary";
import toast from "react-hot-toast";
import UserAddressList from "./UserAddressList";
import AddMyAddress from "../../UserProfileOverview/MyAddress/AddMyAddress/AddMyAddress";

const CheckoutAddress = () => {
  const navigate = useNavigate();
  const location = useLocation();
const [isOrderPlacePending, setIsOrderPlacePending] = useState(false);
const buyNowProduct = location.state?.buyNow
  ? [
      {
        id: location.state.product.id,
        quantity: location.state.quantity,
        product: location.state.product,
      },
    ]
  : null;
  const [countryId] = useState(101);
  const [showForm, setShowForm] = useState(false);
const [favoriteAddressId, setFavoriteAddressId] = useState(() => {
  return localStorage.getItem("favoriteAddressId") || null;
});
 const [selectedAddress, setSelectedAddress] = useState(null);

  const { data: addressList = [], isPending: isPendingAddress } =
    useUserAddressListQuery();

  const savedShipping = JSON.parse(localStorage.getItem("shipping-rules"));

const selectedCartItems = buyNowProduct
  ? buyNowProduct
  : JSON.parse(localStorage.getItem("selectedCheckoutItems")) || [];
const selectedCount = selectedCartItems.length;
const subtotal = selectedCartItems.reduce((acc, item) => {
  const price = Number(
    item.product?.offer_price ||
    item.product?.price ||
    0
  );

  return acc + price * Number(item.quantity || 1);
}, 0);

const totalQty = selectedCartItems.reduce(
  (acc, item) => acc + Number(item.quantity || 1),
  0
);

const shipping = Number(savedShipping?.cost || 0);
const tax = 0;
const total = subtotal + shipping;

const isCartPending = false;



  const orderSummary = {
    subtotal,
    shipping,
    tax,
    total,
    totalQty,
  };

  const existingAddress = {
    name: "",
    email: "",
    phone: "",
    country_id: String(countryId),
    state_id: "",
    city: "",
    zip: "",
    address: "",
    users_id: "",
  };

  const {
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: existingAddress,
  });

  const onSubmit = () => {
    if (!selectedAddress) {
      toast.error("Please select an address");
      return;
    }
    const newUserAddress = {
      id: selectedAddress.id,
      name: selectedAddress.name,
      email: selectedAddress.email,
      phone: selectedAddress.phone,
      country_id: selectedAddress.country_id,
      state_id: selectedAddress.state_id,
      city: selectedAddress.city,
      zip: selectedAddress.zip,
      address: selectedAddress.address,
    };

   localStorage.setItem("checkoutAddress", JSON.stringify(newUserAddress));

setIsOrderPlacePending(true);

setTimeout(() => {
  
    navigate("/checkout/payment", {
      state: location.state,
    });
  
}, 200);
  
  }
  const handleNextToPay = () => handleSubmit(onSubmit)();

const handleSelectAddress = (address) => {
  setSelectedAddress(address);
};
const handleSetFavorite = (addressId) => {
  setFavoriteAddressId(addressId);
  localStorage.setItem("favoriteAddressId", addressId);
};
  return (
    <div className={styles.checkoutContainer}>
      <div className={styles.leftSection}>
        <HeadingTitle text="Delivery Address" style={styles.pageTitle} />

        <div
          className={styles.addAddressCard}
          onClick={() => setShowForm(true)}
        >
          <span className={styles.plus}>
            <FaPlus size={25} />
          </span>
          <p>Add New Address</p>
        </div>

        {showForm && (
          <div className={styles.formWrapper}>
            <AddMyAddress
              mode="add"
              onClose={() => setShowForm(false)}
              onSave={(newAddress) => {
                setSelectedAddress(newAddress);
                setShowForm(false);
              }}
            />
          </div>
        )}

        <ErrorQueryBoundary
          fallback={<Loader title="Loading user addresses.." />}
          errorFallback={<ErrorFallback />}
        >
          {isPendingAddress ? (
            <Loader title="Loading user addresses.." />
          ) : (
            <UserAddressList
              addressList={addressList}
              selectedAddress={selectedAddress}
              onSelect={handleSelectAddress} 
              favoriteAddressId={favoriteAddressId}
  onSetFavorite={handleSetFavorite}
            />
          )}
        </ErrorQueryBoundary>
      </div>

      <div className={styles.rightSection}>
        {isCartPending ? (
          <Loader title="Loading orders..." />
        ) : (
          <CheckoutOrderSummary
             cartItems={selectedCartItems}
            orderSummary={orderSummary}
            isCartPending={isCartPending}
            handlePlaceOrder={handleNextToPay}
           isOrderPlacePending={isOrderPlacePending}
              selectedCount={selectedCount}
          />
        )}
      </div>
    </div>
  );
};

export default CheckoutAddress;